import { useDispatch, useSelector } from 'react-redux'
import { SelectCustom } from '../../../../../../../common/selectCustom'
import { changeYear, selectYear, selectYears } from '../../store/slice'

export const YearSelect = () => {
  const dispatch = useDispatch()

  const years = useSelector(selectYears)
  const year = useSelector(selectYear)

  const chooseItem = (item) => {
    dispatch(changeYear(item.value))
  }

  return (
    <SelectCustom
      isBorderNone
      className="fw600"
      activeItem={{
        label: year,
        value: year,
      }}
      data={years.map((year) => ({
        label: year,
        value: year,
      }))}
      chooseItem={chooseItem}
    />
  )
}
